import domain from '@framework/config/domain';
import env from '@framework/env/env';

const config = {
  name: 'Condor',
  code: 'condor' as const,
  supportEmail: env('FINSIGHT_WEB___SUPPORT__EMAIL'),
  hostname: `${ domain.condorDomain }`,
  supportChatId: env('FRONT_APP__CHAT_ID_TENANT_FINSIGHT'),
  ga: {
// @ts-ignore TODO: FIN-32798 strictNullChecks
    trackingId: null,
  },
  gtm: {
// @ts-ignore TODO: FIN-32798 strictNullChecks
    trackingId: null,
  },
  featureToggle: {
    premiumization: { cookieName: 'premiumization' },
    registrationDialInsEnabled: { cookieName: 'registrationDialInsEnabled' },
    evercallBulkEdit: { cookieName: 'evercallBulkEdit' },
    europeanMarketOpenAccess: { cookieName: 'europeanMarketOpenAccess' },
    evercallPublishFlow: { cookieName: 'evercallPublishFlow' },
    evercallSaveAndNotifyInlineEdit: { cookieName: 'evercallSaveAndNotifyInlineEdit' },
  },
  api: {
    external: `${ domain.protocol }//${ domain.apiDomain }`,
    internal: env('CONDOR_WS__HOSTNAME_INTERNAL'),
    orderBookInternal: env('DM_PORTAL_WS__HOSTNAME_INTERNAL'),
  },
  routes: {
    base: '/core',
    finsight: '/core/finsight',
    drs: '/core/dealroadshow',
  },
};

export default config;
